const Resources = {
    add: () => 'resource',
    view: () => 'resource',
    update: (id: string) => `resource/${id}`,
    getById: (id: string) => `resource/${id}`,
    getDocById: () => `resource/documents`,

}
export default Resources